import type { DeliveryCarrier, DeliveryPricingResponse } from './deliveryPricing';
import { getAnnouncementImageUrl } from './imageUrl';
import { config } from '../config/environment';

export type DeliveryCarrierBrand = {
  src: string;
  alt: string;
};

export const DELIVERY_CARRIER_BRANDS: Record<DeliveryCarrier, DeliveryCarrierBrand> = {
  colissimo: {
    src: '/assets/delivery/colissimo.svg',
    alt: 'Colissimo',
  },
  chronopost: {
    src: '/assets/delivery/chronopost.svg',
    alt: 'Chronopost',
  },
  mondial_relay: {
    src: '/assets/delivery/mondial-relay.svg',
    alt: 'Mondial Relay',
  },
  ups: {
    src: '/assets/delivery/ups.svg',
    alt: 'UPS',
  },
};

export function getDeliveryCarrierBrand(carrier: DeliveryCarrier): DeliveryCarrierBrand {
  return DELIVERY_CARRIER_BRANDS[carrier];
}

/** URL API redirigeant vers le logo uploadé (utilisable en src img, sans preflight CORS). */
export function getDeliveryCarrierLogoApiUrl(
  carrier: DeliveryCarrier,
  locationProviderId?: number
): string {
  const apiBase = config.apiUrl.replace(/\/$/, '');
  const params =
    locationProviderId && locationProviderId > 0
      ? `?location_provider_id=${encodeURIComponent(String(locationProviderId))}`
      : '';
  return `${apiBase}/delivery/carrier-logo/${encodeURIComponent(carrier)}${params}`;
}

export function getCarrierLogoUrlFromPricing(
  pricing: DeliveryPricingResponse | null | undefined,
  carrier: DeliveryCarrier
): string | null {
  if (!pricing) return null;
  const raw =
    pricing.carrier_logos?.[carrier] ??
    (carrier === 'colissimo'
      ? pricing.colissimo.logo_url
      : carrier === 'chronopost'
        ? pricing.chronopost.logo_url
        : carrier === 'ups'
          ? pricing.ups?.logo_url
          : pricing.mondial_relay.logo_url);
  if (!raw) return null;
  const url = getAnnouncementImageUrl(raw);
  return url || null;
}

export function resolveDeliveryCarrierLogoSrc(
  carrier: DeliveryCarrier,
  pricing?: DeliveryPricingResponse | null,
  overrideUrl?: string | null,
  locationProviderId?: number
): string {
  if (overrideUrl) {
    const url = getAnnouncementImageUrl(overrideUrl);
    if (url) return url;
  }
  const fromPricing = getCarrierLogoUrlFromPricing(pricing, carrier);
  if (fromPricing) return fromPricing;
  return getDeliveryCarrierLogoApiUrl(carrier, locationProviderId);
}
